// extracted by mini-css-extract-plugin
module.exports = {"MenuList":"Desktop_MenuList__2392D","btn":"Desktop_btn__2YIy9","button":"Desktop_button__1HAsV","CardMini":"Desktop_CardMini__333J6"};